import { DateTime } from 'luxon';
import { AccountRequest, OnAccount, OnAccountStatus } from './on-account';
import { AdminParsers } from '../../admin/admin-parsers';

export namespace OnAccountParsers {
  export class OnAccountJson {
    userId!: number;
    accountNumber!: string;
    status!: OnAccountStatus;
    requestedAt?: string;
    updatedAt?: string;
    approvedAt?: string;
    approvedBy?: AdminParsers.AdminJson;
  }

  export class AccountRequestJson extends OnAccountJson {
    user!: {
      name: string;
      email: string;
      username: string;
    };
  }

  export function toOnAccount(input: OnAccountJson): OnAccount {
    return {
      ...input,
      requestedAt: input.requestedAt ? DateTime.fromISO(input.requestedAt, { setZone: true }) : undefined,
      updatedAt: input.updatedAt ? DateTime.fromISO(input.updatedAt, { setZone: true }) : undefined,
      approvedAt: input.approvedAt ? DateTime.fromISO(input.approvedAt, { setZone: true }) : undefined,
      approvedBy: input.approvedBy ? AdminParsers.toAdmin(input.approvedBy) : undefined,
    };
  }

  export function toAccountRequest(input: AccountRequestJson): AccountRequest {
    return {
      ...toOnAccount(input),
      user: {
        name: input.user.name,
        email: input.user.email,
      },
    };
  }
}
